module.exports = __webpack_public_path__ + "img/gui_hunyin.e29dc90e.png";